import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import type { Article } from "@/types/news";

export default function HotGrid({ items }: { items: Article[] }) {
  return (
    <section className="w-full bg-background-100 py-10 md:py-12" aria-labelledby="hot-heading">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Hot"
          title="热门爆料"
          description="根据阅读量与讨论热度实时排序，帮你快速抓住当前最受关注的几条线索。"
          moreHref="/channel/all"
          moreLabel="更多爆料"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}